import React, { memo, useState } from 'react';

// import PropTypes from 'prop-types';

import ToolBar from './toolBar';
import ContentTable from './whiteListTable';
import PendingListTable from './pendingListTable';

function ManageWhiteList() {
  const [filter, setFilter] = useState({});
  // const [freshing, setFreshing] = useState(false);
  const handleFilter = (e = {}) => {
    setFilter({ ...filter, ...e });
  };

  return (
    <div className="system-settings-whitelist-wrapper">
      <ToolBar onFilter={handleFilter} />
      <PendingListTable />
      <ContentTable filter={filter} />
    </div>
  );
}

ManageWhiteList.propTypes = {};

export default memo(ManageWhiteList);
